module.exports = __webpack_public_path__ + "static/media/RRD4.365302da.jpg";